import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../../App.js';

const DataVisualization = ({ 
  Ampersandposium, 
  isDarkMode, 
  styles, 
  display, 
  isFlow 
}) => {
  const { vectorVault } = useContext(AuthContext);
  
  // Visualization state
  const [showVisualization, setShowVisualization] = useState(false);
  const [vizLoading, setVizLoading] = useState(false);
  const [maphtml, setMaphtml] = useState(false);
  const [highlightId, setHighlightId] = useState(null);

  // =======================
  // Visualization functions
  // =======================
  const getMap = async (Ampersandposium) => {
    try {
        const highlightIdInt = highlightId !== null ? parseInt(highlightId, 10) : null;
        const html = await vectorVault.fetch3DMap(Ampersandposium, highlightIdInt);
        return html.html;
    } catch (error) {
        console.error("There was an error fetching the data:", error);
        throw error;
    }
  };

  const openInNewWindow = () => {
    const newWindow = window.open('', '_blank');
    if (newWindow) {
      newWindow.document.write(maphtml);
      newWindow.document.write('<style>body { margin: 0; }</style>');
      newWindow.document.close();
    }
  };

  const toggleVisualization = async (shouldClose = 1) => {
    if (!showVisualization || shouldClose === 0) {
      setVizLoading(true)
      try {
        const mapData = await getMap(Ampersandposium);
        setMaphtml(mapData);
      } catch (error) {
        console.error("Error fetching map data:", error);
      }
      setShowVisualization(true);
      setVizLoading(false)
    } else {
      setShowVisualization(false);
      setVizLoading(false)
    }
  };

  // =======================
  // Plotly visualization useEffect
  // =======================
  useEffect(() => {
    if (!maphtml || !showVisualization) return;
  
    const plotlyDiv = document.getElementById('plotly-map');
    if (!plotlyDiv) return;
    
    plotlyDiv.innerHTML = maphtml;
  
    const loadScript = src => {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.onload = resolve;
        script.onerror = reject;
        document.body.appendChild(script);
      });
    };
  
    const scripts = Array.from(plotlyDiv.getElementsByTagName('script'));
    const externalScriptsLoadPromises = scripts
      .filter(script => script.src)
      .map(script => loadScript(script.src));
  
    Promise.all(externalScriptsLoadPromises)
      .then(() => {
        scripts.filter(script => !script.src).forEach(script => {
          const inlineScript = document.createElement('script');
          inlineScript.text = script.text;
          document.body.appendChild(inlineScript).parentNode.removeChild(inlineScript);
        });
  
        const plotlyGraphDiv = plotlyDiv.querySelector('.plotly-graph-div');
        if (plotlyGraphDiv) {
          plotlyGraphDiv.style.height = '700px';
          if (window.Plotly) {
            window.Plotly.Plots.resize(plotlyGraphDiv);
          }
        }
      })
      .catch(error => console.error("Error loading scripts:", error));
  
  }, [maphtml, showVisualization]);

  // Don't render if not applicable
  if (!display || isFlow) {
    return null;
  }

  return (
    <>
      <button 
          onClick={() => toggleVisualization()}
          className={isDarkMode ? 'btn-dark' : 'btn-light'}
          style={{ marginTop: "10px", marginBottom: "10px", marginLeft: "0px" }}
      >
          {showVisualization ? "Close Visualization" : "Visualize Data"}
      </button>
      
      {vizLoading && (
        <div className="loading-spinner" style={{ display: 'block' }}>
            <svg viewBox="0 0 50 50">
                <circle cx="25" cy="25" r="20" stroke="#00d67a" strokeWidth="5" fill="none" />
            </svg>
        </div> 
      )}
      
      {showVisualization && (
        <div style={{ alignItems: 'left', margin: '20px 0' }}>
          <div style={{ marginLeft: '2px' }}>
              <span>Highlight Item:</span>
          </div>
          <div style={{ marginTop: '10px'}}>
              <input
                  className={isDarkMode ? 'sleek-input-dark' : 'sleek-input-light'}
                  type="text"
                  value={highlightId || ''}
                  onChange={(e) => setHighlightId(e.target.value)}
                  placeholder="Item ID"
                  style={{ maxWidth: '80px', fontSize: "1rem", marginLeft: '0px' }}
              />
              <button
                  onClick={() => toggleVisualization(0)}
                  className={isDarkMode ? 'btn-dark' : 'btn-light'}
                  style={{ marginLeft: '6px' }}
              >
                  Regenerate
              </button>
          </div>
        </div>
      )}

      {showVisualization && (
        <>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: "10px" }}>
          <div 
              id="plotly-map"
              className="map-container" 
              style={{ width: '100%', height: '100%' }}
          />
        </div>
        <div style={{ display: 'flex', justifyContent: 'left' }}>
          <button 
            onClick={openInNewWindow} 
            className='link-button'
            style={{ margin: "20px 0" }}
            >
            View in New Tab
          </button>
        </div>
        </>
      )}
    </>
  );
};

export default DataVisualization; 